import { render, staticRenderFns } from "./CommonGrid.vue?vue&type=template&id=6fbfd8c2&scoped=true&"
import script from "./CommonGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommonGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfd8c2",
  null
  
)

export default component.exports